import "./Table.css"
var DeveloperPortalStockDailyRow = function(props){
    return <div className="c_developerportal_companies_searchresults row">
        <div className="col-md-2">{props.date}</div>
        <div className="col-md-2">{props.open}</div>
        <div className="col-md-2">{props.high}</div>
        <div className="col-md-2">{props.low}</div>
        <div className="col-md-2">{props.close}</div>
        <div className="col-md-2">{props.volume}</div>
    </div>
}
export default DeveloperPortalStockDailyRow